/* eslint-disable */
import React from 'react'
import styled from 'styled-components'
import Spinner from './Spinner'
import zIndex from '../../utils/zIndexScale'

const Wrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: ${zIndex.loading};
`

export default () => (
  <Wrap>
    <Spinner />
  </Wrap>
)
